document.documentElement.classList.add('js');

// Mobile nav: slide-out drawer over the page (no layout shift)
const nav = document.getElementById('site-nav');
const toggle = document.querySelector('.nav-toggle');
const overlay = document.querySelector('.nav-overlay');
const setNav = (open) => {
  nav.classList.toggle('is-open', open);
  document.documentElement.classList.toggle('nav-open', open);
  overlay.hidden = !open;
  toggle.setAttribute('aria-expanded', open);
  if (open) nav.querySelector('a, button')?.focus(); else toggle.focus({ preventScroll: true });
};
toggle?.addEventListener('click', () => setNav(!nav.classList.contains('is-open')));
document.querySelectorAll('[data-nav-close]').forEach((el) => el.addEventListener('click', () => setNav(false)));
nav?.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setNav(false)));
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && nav.classList.contains('is-open')) setNav(false); });

// Menu panels: a heading opens its panel, one at a time; a click elsewhere or Escape closes it
const navItems = [...document.querySelectorAll('[data-nav-item]')];
const setPanel = (item, open) => {
  item.querySelector('button').setAttribute('aria-expanded', open);
  item.querySelector('.nav-panel').hidden = !open;
};
navItems.forEach((item) => item.querySelector('button').addEventListener('click', () => {
  const open = item.querySelector('button').getAttribute('aria-expanded') !== 'true';
  navItems.forEach((other) => setPanel(other, other === item && open));
}));
document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav-item]')) navItems.forEach((item) => setPanel(item, false)); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') navItems.forEach((item) => setPanel(item, false)); });
matchMedia('(min-width: 1100px)').addEventListener('change', (m) => { if (m.matches) setNav(false); });

// Announcement bar: rotate one message at a time
const bar = document.querySelector('[data-announcement]');
if (bar && bar.children.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let i = 0;
  setInterval(() => {
    bar.children[i].classList.remove('is-active');
    i = (i + 1) % bar.children.length;
    bar.children[i].classList.add('is-active');
  }, 4500);
}

// Product gallery thumbnails
const mainImg = document.querySelector('[data-main-image]');
const showMedia = (btn) => {
  if (!mainImg || !btn) return;
  mainImg.removeAttribute('srcset');
  mainImg.src = btn.dataset.thumb;
  document.querySelectorAll('.product__thumb').forEach((b) => b.classList.toggle('is-active', b === btn));
};
document.querySelectorAll('.product__thumb').forEach((b) => b.addEventListener('click', () => showMedia(b)));

// Quantity steppers
document.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
  const input = b.parentElement.querySelector('input');
  const max = input.max ? +input.max : Infinity;
  input.value = Math.min(max, Math.max(1, (+input.value || 1) + +b.dataset.qty));
}));

// Variant picker: swap variant id, price, ISBN, availability, image
const productJson = document.querySelector('[data-product-json]');
if (productJson) {
  const product = JSON.parse(productJson.textContent);
  const form = document.querySelector('.product-form');
  const money = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  form.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option]')) return;
    const picked = [...form.querySelectorAll('[data-option]:checked')].map((i) => i.value);
    const variant = product.variants.find((v) => v.options.every((o, i) => o === picked[i]));
    const btn = form.querySelector('[data-add]');
    if (!variant) { btn.disabled = true; btn.textContent = btn.dataset.soldout; return; }
    form.querySelector('[data-variant-id]').value = variant.id;
    document.querySelector('[data-price]').textContent = money(variant.price);
    const compare = document.querySelector('[data-compare]');
    compare.hidden = !(variant.compare_at_price > variant.price);
    if (!compare.hidden) compare.textContent = money(variant.compare_at_price);
    const isbn = document.querySelector('[data-isbn]');
    if (isbn) isbn.textContent = variant.barcode || '';
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? btn.dataset.label : btn.dataset.soldout;
    if (variant.featured_media) showMedia(document.querySelector(`[data-media-id="${variant.featured_media.id}"]`));
    history.replaceState(null, '', `?variant=${variant.id}`);
  });
}

// Cart: quantity changes update the cart right away (no separate Update click)
const cartForm = document.querySelector('[data-cart]');
if (cartForm) {
  let t;
  const submit = () => { clearTimeout(t); t = setTimeout(() => cartForm.querySelector('[data-cart-update]').click(), 450); };
  cartForm.addEventListener('change', (e) => { if (e.target.matches('[data-cart-qty]')) submit(); });
  cartForm.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', submit));
}

// Quick search: drop-down under the header, live results as you type.
// Shopify's predictive search finds the books; titles that match the query rank first.
const qs = document.getElementById('quick-search');
// Two triggers: on the left when the menu is open on the page (desktop), beside the cart when it is a burger.
const qsToggles = [...document.querySelectorAll('[data-search-toggle]')];
if (qs && qsToggles.length) {
  const input = qs.querySelector('[data-search-input]');
  const results = qs.querySelector('[data-search-results]');
  const overlay = document.querySelector('.search-overlay');
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const money = (v) => Number(v).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  const setSearch = (open) => {
    qs.hidden = !open; overlay.hidden = !open;
    qsToggles.forEach((t) => t.setAttribute('aria-expanded', open));
    if (open) input.focus(); else qsToggles.find((t) => t.offsetParent)?.focus({ preventScroll: true });
  };
  const rank = (q, title) => {
    const t = title.toLowerCase();
    return t === q ? 0 : t.startsWith(q) ? 1 : t.split(/\W+/).some((w) => w.startsWith(q)) ? 2 : t.includes(q) ? 3 : 4;
  };
  let timer, ctrl;
  const run = async () => {
    const q = input.value.trim();
    if (!q) { results.innerHTML = ''; return; }
    ctrl?.abort(); ctrl = new AbortController();
    const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
    let products;
    try { products = (await (await fetch(url, { signal: ctrl.signal })).json()).resources.results.products; } catch { return; }
    const lq = q.toLowerCase();
    products = products.map((p, i) => ({ p, i, r: rank(lq, p.title) })).sort((a, b) => a.r - b.r || a.i - b.i).slice(0, 6).map((x) => x.p);
    const all = `<a class="quick-search__all" href="${qs.querySelector('form').action}?q=${encodeURIComponent(q)}&type=product">${esc(results.dataset.viewAll)} “${esc(q)}” →</a>`;
    results.innerHTML = products.length
      ? `<ul class="quick-search__list">${products.map((p) => `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}&width=120" alt="" loading="lazy">` : '<span class="quick-search__noimg"></span>'}<span><strong>${esc(p.title)}</strong><small>${esc(p.vendor)}</small></span><em>${money(p.price)}</em></a></li>`).join('')}</ul>${all}`
      : `<p class="quick-search__empty">${esc(results.dataset.noResults)} “${esc(q)}”.</p>`;
  };
  qsToggles.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); setSearch(qs.hidden); }));
  document.querySelectorAll('[data-search-close]').forEach((el) => el.addEventListener('click', () => setSearch(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !qs.hidden) setSearch(false); });
  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
}

// Dropdowns: any <select data-dropdown> becomes a styled button + option panel.
// The real select stays in the form (hidden) and gets the value + change event.
document.querySelectorAll('select[data-dropdown]').forEach((select, n) => {
  const wrap = document.createElement('div');
  wrap.className = 'dropdown';
  const id = `dropdown-${n}`;
  const label = select.dataset.dropdownLabel;
  wrap.innerHTML = `<button type="button" class="dropdown__button" aria-haspopup="listbox" aria-expanded="false" aria-controls="${id}">${label ? `<span class="dropdown__label">${label}</span>` : ''}<span class="dropdown__value"></span><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5 6 8l4-3.5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button><ul class="dropdown__list" id="${id}" role="listbox" tabindex="-1" hidden></ul>`;
  select.before(wrap);
  wrap.append(select);
  select.hidden = true;
  const button = wrap.querySelector('.dropdown__button');
  const list = wrap.querySelector('.dropdown__list');
  const value = wrap.querySelector('.dropdown__value');
  // Every option label sits in the same grid cell; only the picked one is visible,
  // so the button is always as wide as the longest label and never shifts.
  value.innerHTML = [...select.options].map((o) => `<span>${o.text.replace(/</g, '&lt;')}</span>`).join('');
  const opts = [...select.options].map((o, i) => {
    const li = document.createElement('li');
    li.role = 'option'; li.id = `${id}-${i}`; li.textContent = o.text; li.dataset.i = i;
    list.append(li);
    return li;
  });
  let active = select.selectedIndex;
  const paint = () => {
    [...value.children].forEach((el, i) => el.classList.toggle('is-current', i === select.selectedIndex));
    opts.forEach((li, i) => { li.setAttribute('aria-selected', i === select.selectedIndex); li.classList.toggle('is-active', i === active); });
    list.setAttribute('aria-activedescendant', opts[active]?.id || '');
  };
  const open = (yes) => {
    list.hidden = !yes; button.setAttribute('aria-expanded', yes); wrap.classList.toggle('is-open', yes);
    if (yes) { active = select.selectedIndex; paint(); list.focus(); opts[active]?.scrollIntoView({ block: 'nearest' }); }
  };
  const pick = (i) => {
    open(false); button.focus();
    if (i === select.selectedIndex) return;
    select.selectedIndex = i; paint();
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };
  button.addEventListener('click', () => open(list.hidden));
  list.addEventListener('click', (e) => { const li = e.target.closest('[role=option]'); if (li) pick(+li.dataset.i); });
  list.addEventListener('mousemove', (e) => { const li = e.target.closest('[role=option]'); if (li && +li.dataset.i !== active) { active = +li.dataset.i; paint(); } });
  list.addEventListener('keydown', (e) => {
    const move = { ArrowDown: 1, ArrowUp: -1 }[e.key];
    if (move) { e.preventDefault(); active = Math.max(0, Math.min(opts.length - 1, active + move)); paint(); opts[active].scrollIntoView({ block: 'nearest' }); }
    else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); active = e.key === 'Home' ? 0 : opts.length - 1; paint(); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(active); }
    else if (e.key === 'Escape' || e.key === 'Tab') { open(false); if (e.key === 'Escape') button.focus(); }
  });
  document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) open(false); });
  paint();
});

// Hero slideshow: the track scrolls natively (swipe works without this); this adds dots, arrows and auto-advance
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('[data-slides]').forEach((root) => {
  const track = root.querySelector('[data-slides-track]');
  const dots = [...root.querySelectorAll('[data-slides-dot]')];
  const count = track.children.length;
  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  const go = (i) => track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  track.addEventListener('scroll', () => {
    const i = current();
    dots.forEach((dot, n) => (n === i ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
  }, { passive: true });
  dots.forEach((dot, n) => dot.addEventListener('click', () => go(n)));
  root.querySelector('[data-slides-prev]').addEventListener('click', () => go(current() - 1));
  root.querySelector('[data-slides-next]').addEventListener('click', () => go(current() + 1));
  let timer;
  const stop = () => clearInterval(timer);
  const start = () => { stop(); if (!reduceMotion) timer = setInterval(() => go(current() + 1), root.dataset.interval * 1000); };
  ['pointerenter', 'focusin', 'touchstart'].forEach((type) => root.addEventListener(type, stop, { passive: true }));
  ['pointerleave', 'focusout'].forEach((type) => root.addEventListener(type, start));
  start();
});

// Swipe rows: arrows on desktop, shown only on the side that has more to see
document.querySelectorAll('[data-scroller]').forEach((root) => {
  const track = root.querySelector('[data-scroller-track]');
  const prev = root.querySelector('[data-scroller-prev]');
  const next = root.querySelector('[data-scroller-next]');
  const update = () => {
    prev.hidden = track.scrollLeft < 8;
    next.hidden = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
  };
  const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);
  update();
});

// Contact form: ticking "Sign up for news and updates" also adds the email to the newsletter list
// (the same customer form the footer uses), sent alongside the note itself.
document.querySelectorAll('[data-newsletter-optin]').forEach((box) => {
  const form = box.form;
  form.addEventListener('submit', () => {
    const email = form.querySelector('[name="contact[email]"]').value.trim();
    if (!box.checked || !email) return;
    const data = new FormData();
    data.append('form_type', 'customer');
    data.append('utf8', '✓');
    data.append('contact[email]', email);
    data.append('contact[tags]', 'newsletter');
    fetch(`${window.Shopify?.routes?.root || '/'}contact`, { method: 'POST', body: data, keepalive: true }).catch(() => {});
  });
});
